import { dedicatedReportsApi } from '../../api/dedicatedReports'
import { DedicatedReportShell } from './DedicatedReportShell'
import { FlowTable } from './FlowTable'

/** R3-22 — settori: flusso delle pratiche e, con la lettura amministrativa, il ricavo nei tre stati. */
export function SectorsReportPage() {
  return (
    <DedicatedReportShell title="Report settori" icon="category" load={dedicatedReportsApi.sectors}>
      {d => (
        <>
          <div className="text-muted md-typescale-body-small mb-2">Dal {d.period.from} al {d.period.to}.</div>
          <FlowTable first="Settore" rows={d.rows} />
        </>
      )}
    </DedicatedReportShell>
  )
}
